import "../privacyCentre.css";

export default function TermsAndConditions() {
	return (
		<>
			<h2 className="pc-page-title">Terms and Conditions</h2>
			<h3 className="pc-section-title">
				<strong>1. Terms</strong>
			</h3>
			<p className="pc-detail-text">
				By accessing the website at https://spotlite.co.uk, you are agreeing to be bound by these terms of
				service, all applicable laws and regulations, and agree that you are responsible for compliance with any
				applicable local laws. If you do not agree with any of these terms, you are prohibited from using or
				accessing this site. The materials contained in this website are protected by applicable copyright and
				trademark law.
			</p>
			<h3 className="pc-section-title">
				<strong>2. Use License</strong>
			</h3>
			<p className="pc-detail-text">
				Permission is granted to temporarily download one copy of the materials (information or software) on{" "}
				<em>SpotLite</em>'s website for personal, non-commercial transitory viewing only. This is the grant of a
				license, not a transfer of title, and under this license you may not:
				<ul className="actual-list">
					<li>
						<span>Modify or copy the materials;</span>
					</li>
					<li>
						<span>
							Use the materials for any commercial purpose, or for any public display (commercial or
							non-commercial);
						</span>
					</li>
					<li>
						<span>
							Attempt to decompile or reverse engineer any software contained on <em>SpotLite</em>'s
							website;
						</span>
					</li>
					<li>
						<span>Remove any copyright or other proprietary notations from the materials; or</span>
					</li>
					<li>
						<span>
							Transfer the materials to another person or "mirror" the materials on any other server.
						</span>
					</li>
				</ul>
				This license shall automatically terminate if you violate any of these restrictions and may be
				terminated by <em>SpotLite</em> at any time. Upon terminating your viewing of these materials or upon
				the termination of this license, you must destroy any downloaded materials in your possession whether in
				electronic or printed format.
			</p>
			<h3 className="pc-section-title">
				<strong>3. Disclaimer</strong>
			</h3>
			<p className="pc-detail-text">
				The materials on <em>SpotLite</em>'s website are provided on an 'as is' basis. <em>SpotLite</em> makes
				no warranties, expressed or implied, and hereby disclaims and negates all other warranties including,
				without limitation, implied warranties or conditions of merchantability, fitness for a particular
				purpose, or non-infringement of intellectual property or other violation of rights. Further,{" "}
				<em>SpotLite</em> does not warrant or make any representations concerning the accuracy, likely results,
				or reliability of the use of the materials on its website or otherwise relating to such materials or on
				any sites linked to this site.
			</p>
			<h3 className="pc-section-title">
				<strong>4. Limitations</strong>
			</h3>
			<p className="pc-detail-text">
				In no event shall <em>SpotLite</em> or its suppliers be liable for any damages (including, without
				limitation, damages for loss of data or profit, or due to business interruption) arising out of the use
				or inability to use the materials on <em>SpotLite</em>'s website, even if <em>SpotLite</em> or an{" "}
				<em>SpotLite</em> authorised representative has been notified orally or in writing of the possibility of
				such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations
				of liability for consequential or incidental damages, these limitations may not apply to you.
			</p>
			<h3 className="pc-section-title">
				<strong>5. Accuracy of Materials</strong>
			</h3>
			<p className="pc-detail-text">
				The materials appearing on <em>SpotLite</em>'s website could include technical, typographical, or
				photographic errors. <em>SpotLite</em> does not warrant that any of the materials on its website are
				accurate, complete or current. <em>SpotLite</em> may make changes to the materials contained on its
				website at any time without notice. However <em>SpotLite</em> does not make any commitment to update the
				materials.
			</p>
			<h3 className="pc-section-title">
				<strong>6. Links</strong>
			</h3>
			<p className="pc-detail-text">
				<em>SpotLite</em> has not reviewed all of the sites linked to its website and is not responsible for the
				contents of any such linked site. The inclusion of any link does not imply endorsement by{" "}
				<em>SpotLite</em> of the site. Use of any such linked website is at the user's own risk.
			</p>
			<h3 className="pc-section-title">
				<strong>7. Modifications</strong>
			</h3>
			<p className="pc-detail-text">
				<em>SpotLite</em> may revise these terms of service for its website at any time without notice. By using
				this website you are agreeing to be bound by the then current version of these terms of service.
			</p>
			<h3 className="pc-section-title">
				<strong>8. Governing Law</strong>
			</h3>
			<p className="pc-detail-text">
				These terms and conditions are governed by and construed in accordance with the laws of United Kingdom
				and you irrevocably submit to the exclusive jurisdiction of the courts in that country.
			</p>
			<h3 className="pc-section-title">
				<strong>9. TOS Updates</strong>
			</h3>
			<p className="pc-detail-text">These Terms of Service were last updated on: Monday 15th May, 2023.</p>
		</>
	);
}
